import { ease } from '../../visualizations/common/directives/svgTransition.js';
export const transitionTiming = {
  easing: ease.outCubic,
  duration: 500
};